import * as React from 'react';

// rsuite
import { CustomProvider } from 'rsuite';

// types
import { PlayerConfigProps } from '../../context/useStreamContext/types'

// blocks
import PlayerComponent from './PlayerComponent'


export default function RootComponent(props: PlayerConfigProps) {

  // states
  const [mounted, setMounted] = React.useState(false)

  React.useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  return (
    <CustomProvider theme="dark">
      <PlayerComponent {...props} />
    </CustomProvider>
  );
}
